// Tipi ed etichette del percorso acquirenti, condivisi dalle pagine interne.

export type StatoAppuntamento = 'PRENOTATO' | 'SVOLTO' | 'ANNULLATO' | 'NON_PRESENTATO';
export type OrigineAppuntamento = 'PAGINA_PUBBLICA' | 'LINK_VENDITORE' | 'INTERNO';
export type TipoBuono = 'ATRIO_CONSULENZA' | 'ARAN_SCONTO_CUCINA';
export type StatoBuono = 'EMESSO' | 'UTILIZZATO' | 'CONTRATTO_FIRMATO' | 'SCADUTO' | 'ANNULLATO';
export type UsoImmobile = 'ABITAZIONE' | 'INVESTIMENTO';
export type Orientamento = 'CAPITOLATO' | 'EXTRA_CAPITOLATO' | 'DA_CAPIRE';

export const ETICHETTA_STATO_APPUNTAMENTO: Record<StatoAppuntamento, string> = {
  PRENOTATO: 'Prenotato', SVOLTO: 'Svolto', ANNULLATO: 'Annullato', NON_PRESENTATO: 'Non presentato',
};
export const BADGE_STATO_APPUNTAMENTO: Record<StatoAppuntamento, string> = {
  PRENOTATO: 'bop-badge-info', SVOLTO: 'bop-badge-success', ANNULLATO: 'bop-badge-neutral', NON_PRESENTATO: 'bop-badge-warning',
};
export const ETICHETTA_ORIGINE: Record<OrigineAppuntamento, string> = {
  PAGINA_PUBBLICA: 'Pagina cantiere', LINK_VENDITORE: 'Link personale', INTERNO: 'Dal negozio',
};
export const ETICHETTA_TIPO_BUONO: Record<TipoBuono, string> = {
  ATRIO_CONSULENZA: 'Consulenza Atrio', ARAN_SCONTO_CUCINA: 'Sconto Aran 300 €',
};
export const ETICHETTA_STATO_BUONO: Record<StatoBuono, string> = {
  EMESSO: 'Emesso', UTILIZZATO: 'Utilizzato', CONTRATTO_FIRMATO: 'Contratto firmato', SCADUTO: 'Scaduto', ANNULLATO: 'Annullato',
};
export const BADGE_STATO_BUONO: Record<StatoBuono, string> = {
  EMESSO: 'bop-badge-info', UTILIZZATO: 'bop-badge-warning', CONTRATTO_FIRMATO: 'bop-badge-success', SCADUTO: 'bop-badge-neutral', ANNULLATO: 'bop-badge-neutral',
};
// Stesse regole di backend/src/services/percorsoAcquirenti/regoleBuoni.js.
// Lo stato attuale è sempre il primo: così il form di esito parte con "stato invariato".
export const ESITI_AMMESSI: Record<StatoBuono, StatoBuono[]> = {
  EMESSO: ['EMESSO', 'UTILIZZATO', 'CONTRATTO_FIRMATO', 'ANNULLATO'],
  UTILIZZATO: ['UTILIZZATO', 'EMESSO', 'CONTRATTO_FIRMATO', 'ANNULLATO'],
  CONTRATTO_FIRMATO: ['CONTRATTO_FIRMATO', 'UTILIZZATO'],
  SCADUTO: ['SCADUTO', 'UTILIZZATO', 'CONTRATTO_FIRMATO', 'ANNULLATO'],
  ANNULLATO: [],
};
export const GIORNI_SETTIMANA = ['', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

export interface AppuntamentoAgenda {
  id: number;
  inizio: string;
  fine: string;
  numeroIncontro: number;
  stato: StatoAppuntamento;
  origine: OrigineAppuntamento;
  venditore: { id: number; nome: string };
  acquirente: { id: number; nome: string; cognome: string; unitaCodice: string; telefono: string | null };
  commessa: { id: number; numero: string; sede: { id: number; nome: string }; offertaCapitolato: { oggetto: string } | null };
}

export interface SlotInterno {
  inizio: string;
  fine: string;
  venditore: { id: number; nome: string };
}

export interface BuonoBreve {
  id: number;
  codice: string;
  tipo: TipoBuono;
  stato: StatoBuono;
  emessoAt: string;
  scadenzaAt: string;
  emailInviataAt?: string | null;
}
